import { ReactNode } from 'react';
import { XCircleIcon } from '@heroicons/react/solid';

import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class FolderDeleteHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser) {
    super(history, user);
    this.action = 'deleted';
  }

  detailText(): ReactNode {
    if (this.history.attributes?.migrated) {
      return this.history.attributes?.migrated.description;
    } else {
      return (
        <div data-testid="history-detail-text">
          The folder{' '}
          <span className="font-semibold break-all">{this.history.attributes?.next.name}</span> was{' '}
          {this.action} permanently.
        </div>
      );
    }
  }

  detailIcon(): ReactNode {
    return <XCircleIcon className="h-5 fill-support-error" />;
  }
}
